import { useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';
import { isGlobalFilterKey, useGlobalQueryString } from './useGlobalFilter';

// these slices are relevant only in the scope of functions
// (right now - function pages)
const functionSlices = ['flow', 'service', 'tags'];

export const useFunctionSliceQueryString = (): string => {
  const globalFilters = useGlobalQueryString();
  const [searchParams] = useSearchParams();

  const filteredFunctionSlices = functionSlices
    .filter((filter) => searchParams.get(filter))
    .map((filter) => {
      return `${filter}=${searchParams.get(filter)}`;
    })
    .join('&');
  return [globalFilters, filteredFunctionSlices].filter(Boolean).join('&');
};

export const useFunctionFilters = (): string => {
  const [searchParams] = useSearchParams();

  const filteredParams = useMemo(() => {
    const params = new URLSearchParams();
    searchParams.forEach((value, key) => {
      if (!isGlobalFilterKey(key)) {
        params.append(key, value);
      }
    });
    return params.toString();
  }, [searchParams]);

  return filteredParams;
};
